import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DesktopHeader = _resolveComponent("DesktopHeader")
  const _component_MobileHeader = _resolveComponent("MobileHeader")

  return (!_ctx.isMobile)
    ? (_openBlock(), _createBlock(_component_DesktopHeader, _mergeProps({ key: 0 }, _ctx.$attrs), null, 16))
    : (_openBlock(), _createBlock(_component_MobileHeader, _mergeProps({ key: 1 }, _ctx.$attrs), null, 16))
}